import * as tslib_1 from "tslib";
import * as React from 'react';
import Counter from './Counter';
import CountItem from './CountItem';
import MiniSelect from './MiniSelect';
import QuickJumper from './QuickJumper';
import PaginationWrapper from './PaginationWrapper';
import RightWrapper from './RightWrapper';
/**
 * @ReactComponent
 *
 * 分页组件
 *
 * @class Pagination
 * @extends {React.PureComponent<PaginationPropsType, PaginationStateType>}
 */
var Pagination = /** @class */ (function (_super) {
    tslib_1.__extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
        _this.onPageNumberChange = _this.onPageNumberChange.bind(_this);
        return _this;
    }
    Pagination.prototype.onPageSizeChange = function (event) {
        var itemNum = this.props.total === 0 ? 1 : this.props.total;
        var pageSize = parseInt(event.target.value, 10);
        var pageCount = Math.ceil(itemNum / pageSize);
        var currentPage = pageCount <= this.props.currentPage ? pageCount : this.props.currentPage;
        if (currentPage !== this.props.currentPage &&
            this.props.onPageNumberChange) {
            // 需要对外发布跳到pageCount页的事件
            this.props.onPageNumberChange(pageCount);
        }
        // 需要对外发布pagesize发生变更的事件
        if (this.props.onPageSizeChange) {
            this.props.onPageSizeChange(pageSize);
        }
        if (this.props.onChange) {
            this.props.onChange(currentPage, pageSize);
        }
    };
    Pagination.prototype.onPageNumberChange = function (pageNumber) {
        if (this.props.onPageNumberChange) {
            this.props.onPageNumberChange(pageNumber);
        }
        this.props.onChange(pageNumber, this.props.pageSize);
    };
    Pagination.prototype.render = function () {
        var _a = this.props, _b = _a.pageSize, pageSize = _b === void 0 ? 15 : _b, total = _a.total, onPageNumberChange = _a.onPageNumberChange, onPageSizeChange = _a.onPageSizeChange, _c = _a.currentPage, currentPage = _c === void 0 ? 1 : _c, rest = tslib_1.__rest(_a, ["pageSize", "total", "onPageNumberChange", "onPageSizeChange", "currentPage"]);
        var totalPage = Math.ceil(total / pageSize);
        return (React.createElement(PaginationWrapper, null,
            React.createElement("div", null,
                React.createElement(CountItem, { total: total, currentPage: currentPage, pageSize: pageSize })),
            React.createElement(RightWrapper, null,
                React.createElement(MiniSelect, { value: pageSize, onChange: this.onPageSizeChange }),
                React.createElement(QuickJumper, { onChange: this.onPageNumberChange, totalPage: totalPage, disabled: totalPage === 0 }),
                React.createElement(Counter, { currentPage: currentPage, totalPage: totalPage, onPageNumberChange: this.onPageNumberChange }))));
    };
    return Pagination;
}(React.PureComponent));
export default Pagination;
//# sourceMappingURL=Pagination.js.map